// eslint-disable-next-line import/no-anonymous-default-export
export default {
  customizedCustomer: {
    custom: {
      title: "云扩超自动化平台",
      description: "欢迎使用云扩超自动化平台",
    },
  },
};
